var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSupportAgentFill = function SvgSupportAgentFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "support_agent_fill_svg__a",
    width: 23,
    height: 23,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h23v23H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#support_agent_fill_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "M11.62 19.648a.7.7 0 0 1-.512-.206.7.7 0 0 1-.207-.513q0-.305.207-.512a.7.7 0 0 1 .512-.206h6.284q.12 0 .208-.074a.24.24 0 0 0 .087-.194V11.24q0-2.747-1.966-4.626-1.967-1.88-4.742-1.879T6.749 6.614Q4.783 8.492 4.783 11.24v4.924a.7.7 0 0 1-.207.512.7.7 0 0 1-.512.207q-.69 0-1.183-.48a1.57 1.57 0 0 1-.494-1.17v-1.861q0-.467.265-.854a2 2 0 0 1 .693-.624l.044-1.224a7.35 7.35 0 0 1 .8-2.899 8.043 8.043 0 0 1 4.297-3.864 8.2 8.2 0 0 1 3.005-.552q1.583 0 2.998.552T17 5.442a7.9 7.9 0 0 1 1.778 2.315q.683 1.335.815 2.9l.045 1.2q.418.196.688.563t.27.818v2.14q0 .452-.27.818-.27.368-.688.564v1.183q0 .708-.508 1.206a1.68 1.68 0 0 1-1.225.5zm-2.82-6.45a.83.83 0 0 1-.6-.239.79.79 0 0 1-.248-.59q0-.353.248-.596a.83.83 0 0 1 .6-.243q.352 0 .6.243t.248.595a.79.79 0 0 1-.248.591.83.83 0 0 1-.6.239m5.382 0a.83.83 0 0 1-.6-.239.79.79 0 0 1-.248-.59q0-.353.248-.596a.83.83 0 0 1 .6-.243q.351 0 .6.243.247.243.247.595a.79.79 0 0 1-.248.591.83.83 0 0 1-.6.239m-8.085-1.504q-.15-2.346 1.46-4.015t3.982-1.669q1.994 0 3.519 1.234t1.851 3.195a7.3 7.3 0 0 1-3.773-1.073 7 7 0 0 1-2.659-2.875 6.96 6.96 0 0 1-1.53 3.16 7.1 7.1 0 0 1-2.85 2.043"
  }))));
};
export default SvgSupportAgentFill;